// extracted by mini-css-extract-plugin
export var social = "_8k_Cu";